import { Component, ViewEncapsulation, Output, EventEmitter} from '@angular/core';

@Component({
	selector: 'individual-awards-box',
	templateUrl: './individual-awards-box.component.html',
	styleUrls: ['./individual-awards-box.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class IndividualAwardsBoxComponent {

	@Output() onModalVisibleChange = new EventEmitter<any>();

	constructor() {}

	showAwardeeModal(){
		this.onModalVisibleChange.emit();
	}

	ngOnInit() {}
}